import { InputLabel, Autocomplete, TextField } from "@mui/material";

export function IaxUserSelector({
  uslabelid,
  uslabel,
  usvalue,
  usonchange,
  ususuariosdto,
  usrequired,
  usdisabled,
}) {
  return (
    <>
      <InputLabel id={uslabelid}>{uslabel}</InputLabel>

      <Autocomplete
        options={ususuariosdto ?? []}
        getOptionLabel={(usuario) =>
          usuario != null ? usuario.apellidos + ", " + usuario.nombre : ""
        }
        onChange={usonchange}
        renderInput={(params) => <TextField {...params} variant="outlined" />}
        value={usvalue}
        required={usrequired}
        disabled={usdisabled}
        isOptionEqualToValue={(option, value) => option.id === value.id}
      />
    </>
  );
}
